import moment from 'moment';



export function setupMomentJs() {
	moment.updateLocale('en', {
		week: {
			dow: 1,
		},
	});
}
